import React from 'react';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { ItemTypes } from './ItemTypes';

const SquareShape = ({
  shape: { position, dimension, ...shape },
  isSelected,
  ...props
}) => {
  const [{ isDragging }, drag, preview] = useDrag(
    () => ({
      type: ItemTypes.SHAPE,
      item: {
        id: shape.id,
        position,
        name: shape.name,
      },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [shape.id, position.left, position.top, shape.name],
  );
  React.useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, []);
  let baseClassName = 'd-flex justify-content-center align-items-center';
  let className =
    baseClassName + (isSelected ? ' map-editor-shape--selected' : '');
  return (
    <div
      key={shape.id}
      id={shape.id}
      ref={drag}
      role="Shape"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        props.onSelectShape({ position, dimension, ...shape });
      }}
      className={className}
      style={{
        position: 'absolute',
        ...position,
        ...dimension,
        ...shape,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: 'black',
        backgroundColor: shape.alarmBackgroundColor,
      }}
    >
      {/* {shape.alarmValue} */}
    </div>
  );
};

export default SquareShape;
